module.exports = __webpack_public_path__ + "static/img/4@2x.a59d88f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/4@2x.png
// module id = ZgIR
// module chunks = 8